<template>
    <div class="pagination">
        <app-button
            class="pagination__button"
            :disabled="currentPage === 1"
            @click.native="currentPage !== 1 && onPagination(currentPage - 1)"
        >
            <app-icon name="arrow-left" class="pagination__icon" />
        </app-button>

        <template v-for="i in numPages">
            <app-button
                v-if="currentPage === i"
                theme="highlight"
                :key="i"
                class="pagination__button"
            >{{ i }}</app-button>
            <app-button
                v-else
                :key="i"
                class="pagination__button"
                @click.native="onPagination(i)"
            >{{ i }}</app-button>
        </template>

        <app-button
            class="pagination__button"
            :disabled="isLastPage"
            @click.native="!isLastPage && onPagination(currentPage + 1)"
        >
            <app-icon name="arrow-right" class="pagination__icon" />
        </app-button>
    </div>
</template>

<script>
import AppIcon from '@/components/ui/Icon.vue'
import AppButton from '@/components/ui/Button.vue'

export default {
    components: { AppIcon, AppButton },

    props: {
        page: { type: Number, default: 1 },
        maxItemsPerPage: { type: Number, default: 1 },
        numDocuments: { type: Number, default: 1 },
        numPages: { type: Number, default: 1 },
    },

    data () {
        return {
            currentPage: this.page,
        }
    },

    computed: {
        isLastPage () {
            return this.currentPage * this.maxItemsPerPage >= this.numDocuments
        },
    },

    methods: {
        onPagination (payload) {
            this.currentPage = payload
            this.$emit('update', this.currentPage)
        },
    },
}
</script>

<style lang="scss" scoped>
.pagination {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-unit-6;
    justify-content: center;
}
</style>
